import React from 'react';

import { Company, isServiceTitanPortalV2Company, isStCapacityCompany } from '_lib/api/apiTypes.shim';

import { Box } from '_lib/components/Box/Box';
import { Chip } from '_lib/components/Chip/Chip';
import { Divider } from '_lib/components/Divider/Divider';
import { ExternalLinkOrDefault } from '_lib/components/ExternalLinkOrDefault/ExternalLinkOrDefault';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';
import { Stack } from '_lib/components/Stack/Stack';
import { Typography } from '_lib/components/Typography/Typography';

import { CompanyLabels } from '_lib/constants/company.constants';
import { HeaderBox } from '_lib/featureComponents/HeaderBox/HeaderBox';
import { HeaderTextBlock } from '_lib/featureComponents/HeaderTextBlock/HeaderTextBlock';

import { AvailabilityScheduleMessage } from '../AvailabilityScheduleMessage/AvailabilityScheduleMessage';
import { FormattedContactBlock } from '../FormattedContactBlock/FormattedContactBlock';

type CompanyAllZonesProps = {
  company: Company;
};

export const CompanyAllZones = (props: CompanyAllZonesProps): React.ReactElement => {
  const { company } = props;
  const { zones, isScheduleEnabled } = company;

  return (
    <Box sx={{ px: 3 }}>
      {zones.map((zone, index) => (
        <Box key={zone.id} sx={{ py: 1 }}>
          <Stack spacing={2}>
            <Typography variant='h3' text={zone.title} sx={{ textAlign: 'center' }} />
            <HeaderBox headerText='Zip Codes'>
              <FlexBox sx={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                {zone.zipCodes.map((zipCode, zipIndex) => (
                  <Chip key={zipIndex} label={zipCode} variant='outlined' />
                ))}
              </FlexBox>
            </HeaderBox>
            <HeaderTextBlock headerText='Dispatch Rules' text={zone.callCenter.dispatchRules} />
            <HeaderTextBlock headerText='Big Ticket Items' text={zone.callCenter.bigTicketItems} />
            <HeaderTextBlock headerText='Big Ticket Item Rules' text={zone.callCenter.bigTicketItemRules} />
            <HeaderTextBlock headerText='Warranty Rules' text={zone.callCenter.warrantyRules} />
            <HeaderTextBlock headerText='Notes' text={zone.callCenter.notes} />
            {!isScheduleEnabled && !isStCapacityCompany(company) && (
              <HeaderBox headerText='Schedule URL'>
                <ExternalLinkOrDefault
                  url={zone.callCenter.scheduleUrl}
                  label={CompanyLabels.SCHEDULE_URL}
                  defaultValue={
                    isServiceTitanPortalV2Company(company) ? (
                      <AvailabilityScheduleMessage company={company} />
                    ) : undefined
                  }
                />
              </HeaderBox>
            )}
            <Stack direction='row' sx={{ justifyContent: 'flex-start' }}>
              <HeaderBox headerText='PRIMARY CONTACT' sx={{ width: '50%' }}>
                <FormattedContactBlock contact={zone.primaryContact} />
              </HeaderBox>
              <HeaderBox headerText='SECONDARY CONTACT' sx={{ width: '50%' }}>
                <FormattedContactBlock contact={zone.secondaryContact} />
              </HeaderBox>
            </Stack>
            {index < zones.length - 1 && <Divider />}
          </Stack>
        </Box>
      ))}
    </Box>
  );
};
